import { Order, OrderTypeEnum, PackageKindEnum } from '@portal/schema';

type OrderInput = Pick<Order, 'id' | 'type' | 'accountPackages'>;

export const getMovingPackingMaterials = (order?: OrderInput) => {
  if (order?.type !== OrderTypeEnum.Move) return undefined;
  return order.accountPackages.find(({ kind }) => kind === PackageKindEnum.PackingSupplies);
};
